import { Box, Checkbox, FormControlLabel, Slider } from '@material-ui/core'
import { useState } from 'react'

import { transformUnderscoreInSpaceAndUppercaseFirstLetter } from '@/utils/format-strings'

import { useStyles } from './styles'

const marks = Array.from({ length: 16 }).map((_, index) => ({
  value: index,
  label: index === 0 || index === 15 ? `${index} m` : undefined,
}))

interface ListItemProps {
  name: string
  bgColor: string
  border: string
  buffer: number
  buffered: boolean
  onSlideChange: (value: number) => void
  onCheckBufferChange: (checked: boolean) => void
}

export function ListItem({
  name,
  bgColor,
  border,
  buffer,
  buffered,
  onSlideChange,
  onCheckBufferChange: onBufferChange,
}: ListItemProps) {
  const classes = useStyles()

  const [slideValue, setSlideValue] = useState(buffer)

  function handleChangeSlide(value: number) {
    setSlideValue(value)
  }

  return (
    <li>
      <span>
        {transformUnderscoreInSpaceAndUppercaseFirstLetter(name)}
        <Box
          bgcolor={bgColor}
          minWidth={16}
          minHeight={16}
          maxWidth={16}
          maxHeight={16}
          borderRadius={4}
          display='inline-block'
          style={{
            border,
          }}
        />
      </span>

      <Box marginX='1.4rem'>
        <Slider
          className={classes.slider}
          color='secondary'
          valueLabelDisplay={buffered ? 'on' : 'off'}
          value={buffered ? slideValue : 0}
          disabled={!buffered}
          track={false}
          marks={marks}
          min={0}
          max={15}
          onChange={(_, value) => handleChangeSlide(Number(value))}
          onChangeCommitted={(_, value) => onSlideChange(Number(value))}
        />
      </Box>

      <FormControlLabel
        name={name}
        control={<Checkbox size='small' />}
        checked={!buffered}
        onChange={(_, checked) => onBufferChange(checked)}
        label='Não utilizar buffer nesta camada'
      />
    </li>
  )
}
